<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home-page']"
    titlePrefix="Ramnil - Maximize Your Advertising Impact"
    metaDescription="Connect with premium ad inventory, leverage real-time bidding, and optimize campaigns with data-driven insights. Trusted technology and expert support help you reach the right audience and achieve measurable results.">

    <section class="hero-section">
      <div class="hero-section__content">
        <h1 class="hero-section__title">Precision Advertising for Modern Growth</h1>
        <p class="hero-section__subtitle">
          Unlock smarter campaigns with data-driven strategy, premium inventory access, and transparent performance analytics. 
        </p>
        <a href="/#footer-section" class="hero-section__cta-button">
          <span>Contact Us</span>
          <img src="@/assets/banner-contact-arrow.svg" alt="arrow">
        </a>
      </div>
    </section>

    <section class="data-section">
      <div class="data-section__item" v-for="(item, index) in dataItems" :key="index">
        <div class="data-section__value">{{ item.value }}</div>
        <div class="data-section__label">{{ item.label }}</div>
      </div>
    </section>

    <section class="services-section">
      <div class="services-section__header">
        <h2 class="services-section__title">What We Provide for Your Growth</h2>
        <p class="services-section__subtitle">
          We connect you to quality ad inventory and smart optimization tools—helping you scale confidently and maximize every campaign’s return.
        </p>
      </div>
      <div class="services-section__grid">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <img :src="service.image" :alt="service.title" class="service-card__image">
          <div class="service-card__content">
            <h3 class="service-card__title">{{ service.title }}</h3>
            <p class="service-card__description">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="why-section">
      <div class="why-section__header">
        <h2 class="why-section__title">Why choose us?</h2>
        <p class="why-section__subtitle">
          Advanced technology, dedicated expertise, and reliable service to drive your advertising success.
        </p>
      </div>
      <div class="why-section__content">
        <div class="why-section__image-container">
          <img src="@/assets/why.png" alt="Why choose us placeholder" class="why-section__image">
        </div>
        <div class="why-section__features">
          <div class="feature-item" v-for="(feature, index) in features" :key="index">
            <div class="feature-item__number">{{ index + 1 }}</div>
            <div class="feature-item__text">
              <h3 class="feature-item__title">{{ feature.title }}</h3>
              <p class="feature-item__description">{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="trust-section">
      <p class="trust-section__text">Trusted by Industry Leaders Worldwide</p>
    </section>

    <section class="partners-section">
      <div class="partners-section__header">
        <h2 class="partners-section__title">Partners</h2>
      </div>
      <div class="partners-section__grid">
        <div class="partner-logo" v-for="(partner, index) in partners" :key="index">
          <img :src="partner.image" :alt="partner.name">
        </div>
      </div>
    </section>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
  },
  mixins: [common],
  data () {
    return {
      dataItems: [
        { value: '800M+', label: 'High-quality impressions delivered monthly across premium inventory.' },
        { value: '98%', label: 'Account onboarding success rate for fast and seamless campaign activation.' },
        { value: '24/7', label: 'Live performance tracking to keep your ads optimized around the clock.' }
      ],
      services: [
        {
          title: 'Cross-Channel Campaigns',
          description: 'Run coordinated ads across display, social, video, and mobile channels.',
          image: require('@/assets/service-1.png')
        },
        {
          title: 'Creative Solutions',
          description: 'Optimize ad creatives with A/B testing, dynamic content, and personalization.',
          image: require('@/assets/service-2.png')
        },
        {
          title: 'Fraud Protection',
          description: 'Ensure safe ad placements with automated fraud detection and brand safety checks.',
          image: require('@/assets/service-3.png')
        },
        {
          title: 'Performance Analytics',
          description: 'Track, measure, and report campaign results in real time for data-driven decisions.',
          image: require('@/assets/service-4.png')
        }
      ],
      features: [
        {
          title: 'Global Platform Access',
          description: 'Seamlessly connect to top ad networks and platforms to reach your ideal audience anywhere.'
        },
        {
          title: 'Expert Support Team',
          description: 'Receive personalized guidance from experienced professionals for smooth campaign execution.'
        },
        {
          title: 'Transparent Reporting',
          description: 'Get clear insights and performance metrics for every campaign, ensuring accountability and efficiency.'
        }
      ],
      partners: [
        { name: 'Amazon', image: require('@/assets/Amazon.png') },
        { name: 'Yandex', image: require('@/assets/Yandex.png') },
        { name: 'Zalora', image: require('@/assets/Zalora.png') },
        { name: 'Google', image: require('@/assets/Google.png') },
        { name: 'Tinder', image: require('@/assets/Tinder.png') },
        { name: 'Meta', image: require('@/assets/Meta.png') },
        { name: 'Telecoming', image: require('@/assets/Telecoming.png') },
        { name: 'TikTok', image: require('@/assets/TikTok.png') }
      ]
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  methods: {
    scrollToSection (hash) {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },

  }
};
</script>

